module.exports = __webpack_public_path__ + "ee05a16fdc12444d1123cb9910436220.svg";